import React from 'react';
import s from './certificates.module.css';

export default function Certificates() {
  return (
    <div>
      {' '}
      <h2 className={s.title}>Тут буде сторiнка Сертифікатiв</h2>{' '}
    </div>
  );
}
